// Geo headers (cf-ipcountry, region-isocode) are forwarded implicitly via
// req.headers spread in the proxy handler — Cloudflare sets them on the
// browser→Next.js hop and they pass through to Rails unchanged.
//
// Note: X-Forwarded-Proto is included here but the proxy handler in
// [...proxy].api.ts deletes all x-forwarded-* headers before sending.
// It only takes effect for non-proxy callers of this function.
export const getHeaders = () => ({
  'Content-Type': 'application/json',
  'X-Forwarded-Proto': 'https',
  'Requested-By': 'educator',
})
